// O que a Central sabe dizer sobre um anexo: tipo legível, cor do ícone, se
// dá pra visualizar dentro do painel e o nome que aparece pro atendente.

import type { ChatwootAttachment } from '@/api/endpoints/support';

export type TipoVisual = 'imagem' | 'video' | 'audio' | 'pdf' | 'documento';

export interface InfoArquivo {
  tipo: TipoVisual;
  /** Rótulo curto no cartão: PDF, DOCX, XLSX... */
  rotulo: string;
  /** Classes do quadrado do ícone (fundo + texto). */
  cor: string;
  nome: string;
  tamanho: string;
  /** Abre no visualizador do painel (imagem, vídeo, PDF). */
  visualizavel: boolean;
}

const CORES: Record<string, string> = {
  pdf: 'bg-red-500/15 text-red-500',
  doc: 'bg-blue-500/15 text-blue-500',
  docx: 'bg-blue-500/15 text-blue-500',
  xls: 'bg-emerald-500/15 text-emerald-600',
  xlsx: 'bg-emerald-500/15 text-emerald-600',
  csv: 'bg-emerald-500/15 text-emerald-600',
  ppt: 'bg-orange-500/15 text-orange-500',
  pptx: 'bg-orange-500/15 text-orange-500',
};

const NOME_PADRAO: Record<TipoVisual, string> = {
  imagem: 'Imagem',
  video: 'Vídeo',
  audio: 'Áudio',
  pdf: 'Documento PDF',
  documento: 'Documento',
};

export function formatarTamanho(bytes?: number): string {
  if (!bytes || bytes <= 0) return '';
  if (bytes < 1024) return `${bytes} B`;
  const kb = bytes / 1024;
  if (kb < 1024) return `${Math.round(kb)} KB`;
  return `${(kb / 1024).toFixed(1).replace('.', ',')} MB`;
}

function extensaoDe(att: ChatwootAttachment): string {
  if (att.extension) return att.extension.toLowerCase();
  const fonte = att.file_name || att.data_url || '';
  const m = fonte.split('?')[0].match(/\.([a-z0-9]{1,5})$/i);
  return m ? m[1].toLowerCase() : '';
}

export function infoDoArquivo(att: ChatwootAttachment): InfoArquivo {
  const ext = extensaoDe(att);
  let tipo: TipoVisual = 'documento';
  if (att.file_type === 'image') tipo = 'imagem';
  else if (att.file_type === 'video') tipo = 'video';
  else if (att.file_type === 'audio') tipo = 'audio';
  else if (ext === 'pdf' || att.content_type === 'application/pdf') tipo = 'pdf';

  return {
    tipo,
    rotulo: (ext || NOME_PADRAO[tipo]).toUpperCase(),
    cor: CORES[ext] || 'bg-elevated text-text-secondary',
    nome: att.file_name || NOME_PADRAO[tipo],
    tamanho: formatarTamanho(att.file_size),
    visualizavel: tipo === 'imagem' || tipo === 'video' || tipo === 'pdf',
  };
}

// Item do visualizador em tela cheia (navega entre todas as mídias da conversa).
export interface ItemMidia {
  chave: string;
  messageId: number;
  url: string;
  tipo: 'imagem' | 'video' | 'pdf';
  nome: string;
  legenda?: string | null;
  quando?: number;
  deQuem: string;
}
